import type { RefObject } from 'react';
import { fadeTo } from 'util/animation/fade/fade';

interface StickyNotesRefs {
  elementRef: RefObject<HTMLElement>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: StickyNotesRefs,
): void {
  timeline.fromTo(elementRef.current, {}, {});
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: StickyNotesRefs,
): void {
  timeline.add(fadeTo(elementRef.current as HTMLElement));
}
